import krooloIntro from "@/assets/images/videos/gettingStarted/kroolo-intro.svg";
import completeKrooloDemo from "@/assets/images/videos/gettingStarted/complete-kroolo-demo.svg";
import signUp from "@/assets/images/videos/gettingStarted/sign-up.svg";
import signUpUsingEmail from "@/assets/images/videos/gettingStarted/sign-up-using-email.svg";
import krooloAI from "@/assets/images/videos/krooloAi/introduction-to-kroolo-ai.svg";
import createProjectKrooloAI from "@/assets/images/videos/krooloAi/create-project-using-kroolo-ai.svg";
import chatWithProjects from "@/assets/images/videos/krooloAi/chat-with-projects.svg";
import createGoalUsingKrooloAI from "@/assets/images/videos/krooloAi/create-goal-using-kroolo-ai.svg";
import createDocUsingKrooloAI from "@/assets/images/videos/krooloAi/create-doc-using-kroolo-ai.svg";
import chatWithDocUsingKrooloAI from "@/assets/images/videos/krooloAi/chat-with-doc-using-kroolo-ai.svg";
import chatWithAnythingUsingAI from "@/assets/images/videos/krooloAi/chat-with-anything-using-kroolo-ai.svg";
import createGoalsKrooloAI from "@/assets/images/videos/goals/create-goals-kroolo-ai.svg";
import createGoalsUsingBlankTemplate from "@/assets/images/videos/goals/create-goals-using-blank-template.svg";
import inviteMemberToYourGoal from "@/assets/images/videos/goals/invite-member-to-your-goal.svg";
import createSubGoal from "@/assets/images/videos/goals/create-sub-goal.svg";
import createManageTasks from "@/assets/images/videos/tasks/create-manage-tasks.svg";
import updatemultipleTaskProperties from "@/assets/images/videos/tasks/update-multiple-task-properties.svg";
import createDependenciesInTasks from "@/assets/images/videos/tasks/create-dependencies-in-tasks.svg";
import createSubTasksUsingKroolo from "@/assets/images/videos/tasks/create-subtasks-using-kroolo-ai.svg";
import updateKeyResultsInGoals from "@/assets/images/videos/goals/update-key-results-in-goals.svg";
import createManageChannels from "@/assets/images/videos/chat/create-and-manage-channels.svg";
import addMembersInChannels from "@/assets/images/videos/chat/add-members-in-channels.svg";
import sendVoiceNotesInChannels from "@/assets/images/videos/chat/send-voice-notes-in-channels.svg";
import convertMessagesIntoTasks from "@/assets/images/videos/chat/convert-messages-into-tasks.svg";
import mentionAnythingInChannels from "@/assets/images/videos/chat/mention-anything-in-channels.svg";
import createAndManageTeams from "@/assets/images/videos/teams/create-and-manage-teams.svg";
import manageMembersInTeams from "@/assets/images/videos/teams/manage-members-in-teams.svg";
import createDocsUsingKrooloAi from "@/assets/images/videos/docs/create-docs-using-kroolo-ai.svg";
import chatWithDocsUsingKrooloAI from "@/assets/images/videos/docs/chat-with-doc-using-kroolo-ai.svg";
import embededFilesInDocs from "@/assets/images/videos/docs/embeded-files-in-doc.svg";
import shareDocs from "@/assets/images/videos/docs/share-docs.svg";
import manageDocs from "@/assets/images/videos/docs/manage-docs.svg";
import createSubDocs from "@/assets/images/videos/docs/create-subdocs.svg";
import importDocsFromConfluence from "@/assets/images/videos/docs/import-docs-from-confluence.svg";
import createProjectCompleteGuide from "@/assets/images/videos/projects/create-project-complete-guide.svg";
import createProjectsUsingBlankTempelate from "@/assets/images/videos/projects/create-project-using-blank-tempelate.svg";
import createProjectUsingPreBuiltTempelates from "@/assets/images/videos/projects/create-project-using-pre-built-tempelates.svg";
import createProjectUsingKrooloAi from "@/assets/images/videos/projects/create-project-using-kroolo-ai.svg";
import manageProjects from "@/assets/images/videos/projects/manage-projects.svg";
import chatWithProjectsinProjects from "@/assets/images/videos/projects/chat-with-projects-in-projects.svg";
import inviteMembersToProjects from "@/assets/images/videos/projects/invite-members-to-projects.svg";
import manageWorkloadInProjects from "@/assets/images/videos/projects/manage-workload-in-projects.svg";
import createSprintsInProjects from "@/assets/images/videos/projects/create-sprints-in-projects.svg";
import manageSprints from "@/assets/images/videos/projects/manage-sprints.svg";
import importProjectsFromTrello from "@/assets/images/videos/integrations/projects-from-trello.svg";
import jiraIntegration from "@/assets/images/videos/integrations/jira-integration.svg";
import asanaIntegration from "@/assets/images/videos/integrations/asana-integration.svg";
import importProjectsFromClickUp from "@/assets/images/videos/integrations/projects-from-clickup.svg";
import todoistIntegration from "@/assets/images/videos/integrations/todoist-integration.svg";
import linearIntegration from "@/assets/images/videos/integrations/linear-integration.svg";
import tickTickIntegration from "@/assets/images/videos/integrations/ticktick-integration.svg";
import smartsheetIntegration from "@/assets/images/videos/integrations/smartsheet-integration.svg";
import basecampIntegration from "@/assets/images/videos/integrations/basecamp-integration.svg";
import airtableIntegration from "@/assets/images/videos/integrations/airtable-integration.svg";
import syncGithubWithProjects from "@/assets/images/videos/integrations/sync-github-with-projects.svg";
import syncGitLabWithProjects from "@/assets/images/videos/integrations/sync-gitlab-with-projects.svg";
import createAndManageAutomations from "@/assets/images/videos/automations/create-and-manage-automations.svg";
import outlookEmailAutomation from "@/assets/images/videos/automations/outlook-email-automation.svg";
import automateGmailUpdates from "@/assets/images/videos/automations/automate-gmail-updates.svg";
import reassignTasksAutomatically from "@/assets/images/videos/automations/reassign-tasks-automatically.svg";
import addHubspotAutomationsInProjects from "@/assets/images/videos/automations/add-hubspot-automations-in-projects.svg";
import salesforceAutomation from "@/assets/images/videos/automations/salesforce-automations.svg";
import { StaticImageData } from "next/image";

export type Video = {
  id: number;
  videoid: string;
  title: string;
  description: string;
  thumb: StaticImageData;
  alt?: string;
  tabId?: number;
};

export type VideosData = {
  [key: string]: Video[];
};

export const videosData: VideosData = {
  gettingStarted: [
    {
      videoid: "_8d0wPlBLDE",
      title: "What is Kroolo",
      description:
        "This video gives you a quick overview of Kroolo and its key features.",
      id: 1,
      thumb: krooloIntro,
    },
    {
      videoid: "8QoxZLGILqs",
      title: "Complete Kroolo Demo",
      description:
        "This video shows you how Kroolo works from start to finish.",
      id: 1,
      thumb: completeKrooloDemo,
    },
    {
      videoid: "XTraOhd4i4U",
      title: "Sign up and onboarding",
      description:
        "Follow this guide to sign up and complete your onboarding process with Kroolo",
      id: 1,
      thumb: signUp,
    },
    {
      videoid: "6S6Mcp240C4",
      title: "Sign Up Using Email",
      description:
        "This video walks you through the process of signing up with your email.",
      id: 1,
      thumb: signUpUsingEmail,
    },
  ],
  krooloAi: [
    {
      videoid: "A6gEIkcvzZY",
      title: "Introduction to Kroolo AI",
      description:
        "Watch this video to get an overview of Kroolo AI and its capabilities.",
      id: 2,
      thumb: krooloAI,
    },
    {
      videoid: "uoeQ0-LyfFI",
      title: "Create a Project Using Kroolo AI",
      description:
        "This guide shows you how you can create projects using Blank Template.",
      id: 2,
      thumb: createProjectKrooloAI,
    },
    {
      videoid: "GqhPGmwYSnA",
      title: "Chat with Projects",
      description:
        "In this video, you’ll learn how to use Kroolo AI to chat with your projects.",
      id: 2,
      thumb: chatWithProjects,
    },
    {
      videoid: "r_95Xd8p-lo",
      title: "Create a Goal using Kroolo AI",
      description:
        "This video shows you how you can create a goal using Kroolo AI.",
      id: 2,
      thumb: createGoalUsingKrooloAI,
    },
    {
      videoid: "kSP--iBZTeE",
      title: "Create Docs Using Kroolo AI",
      description:
        "Watch this video to see how to use Kroolo AI to create documents.",
      id: 2,
      thumb: createDocUsingKrooloAI,
    },
    {
      videoid: "Ho-If9K2ixk",
      title: "Chat with Docs Using Kroolo AI",
      description:
        "In this video, you’ll see how to chat with documents using the Kroolo AI.",
      id: 2,
      thumb: chatWithDocUsingKrooloAI,
    },
    {
      videoid: "IRVu0ZeJxBg",
      title: "Chat with Anything using Kroolo AI",
      description:
        "This video shows how to chat with PDFs, images, Excel files, and more using Kroolo AI.",
      id: 2,
      thumb: chatWithAnythingUsingAI,
    },
  ],
  goals: [
    {
      videoid: "r_95Xd8p-lo",
      title: "Create Goals Kroolo AI",
      description:
        "Watch this video to see how to create and manage goals using Kroolo AI.",
      id: 3,
      thumb: createGoalsKrooloAI,
    },
    {
      videoid: "81G2tn-u6pw",
      title: "Create Goals using a Blank Template",
      description:
        "This video explains how you can create goals using a blank template.",
      id: 3,
      thumb: createGoalsUsingBlankTemplate,
    },
    {
      videoid: "aoHtx7qkp7E",
      title: "Invite a Member to Your Goal",
      description:
        "In this video, you’ll learn how to invite a team member to your goal.",
      id: 3,
      thumb: inviteMemberToYourGoal,
    },
    {
      videoid: "9U11tm25JwU",
      title: "Create a Sub-Goal",
      description:
        "Watch this video to see how to create a sub-goal within your goals.",
      id: 3,
      thumb: createSubGoal,
    },
    {
      videoid: "WrB3TiZhukE",
      title: "Update Key Results in Goals",
      description:
        "This video shows how to update key results within your goals.",
      id: 3,
      thumb: updateKeyResultsInGoals,
    },
  ],
  projects: [
    {
      videoid: "qfcEiy-G9uQ",
      title: "Create a Project Complete Guide",
      description:
        "This video covers how to create a project using a blank template, AI, and pre-made templates.",
      id: 4,
      thumb: createProjectCompleteGuide,
    },
    {
      videoid: "-rf_cwV_UWs",
      title: "Create Projects using Blank Template",
      description:
        "In this video, you’ll learn how to set up a project using a blank template.",
      id: 4,
      thumb: createProjectsUsingBlankTempelate,
    },
    {
      videoid: "8vaQYFRYhvg",
      title: "Create Projects Using Pre-Built Templates",
      description:
        "Learn how to quickly set up a project using Kroolo’s pre-built templates.",
      id: 4,
      thumb: createProjectUsingPreBuiltTempelates,
    },
    {
      videoid: "uoeQ0-LyfFI",
      title: "Create Projects using Kroolo AI",
      description:
        "In this video, you’ll learn how to set up projects using Kroolo AI.",
      id: 4,
      thumb: createProjectUsingKrooloAi,
    },
    {
      videoid: "PYqwsza9pMU",
      title: "Manage Projects",
      description:
        "Watch this video to see how to efficiently manage your projects in Kroolo.",
      id: 4,
      thumb: manageProjects,
    },
    {
      videoid: "GqhPGmwYSnA",
      title: "Chat with Projects",
      description:
        "In this video, you’ll learn how to use Kroolo AI to chat with your projects.",
      id: 4,
      thumb: chatWithProjectsinProjects,
    },
    {
      videoid: "8ZBXwUGWQQo",
      title: "Invite Members to Projects",
      description:
        "This video shows how to invite a team member to collaborate on your project.",
      id: 4,
      thumb: inviteMembersToProjects,
    },
    {
      videoid: "aeBQX95uZgQ",
      title: "Manage Workload in Projects",
      description:
        "Watch this video to see how to manage and adjust workloads in your projects.",
      id: 4,
      thumb: manageWorkloadInProjects,
    },
    {
      videoid: "IxYOYoEv8qA",
      title: "Create Sprints in Projects",
      description:
        "This video shows how to create sprints within your projects.",
      id: 4,
      thumb: createSprintsInProjects,
    },
    {
      videoid: "lXS92L1x05I",
      title: "Manage Sprints",
      description: "This video shows how to manage sprints effectively.",
      id: 4,
      thumb: manageSprints,
    },
  ],
  tasks: [
    {
      videoid: "oBQPNz9v1Zo",
      title: "Create and Manage Tasks",
      description:
        "Watch this video to see how to create, update, and manage tasks easily.",
      id: 5,
      thumb: createManageTasks,
    },
    {
      videoid: "yyDiB9OF1Jo",
      title: "Update Multiple Task Properties",
      description: "Learn how to change several task properties quickly.",
      id: 5,
      thumb: updatemultipleTaskProperties,
    },
    {
      videoid: "er-ZWfe8BS8",
      title: "Create Subtasks using Kroolo AI",
      description:
        "This video shows how you can create subtasks using Kroolo AI.",
      id: 5,
      thumb: createSubTasksUsingKroolo,
    },
    {
      videoid: "TShK0ikb4_k",
      title: "Create Dependencies in Tasks",
      description:
        "Watch this video to see how to create task dependencies in your projects.",
      id: 5,
      thumb: createDependenciesInTasks,
    },
  ],
  chat: [
    {
      videoid: "iD6oJwuu6_E",
      title: "Create and Manage Channels",
      description:
        "This video shows how to create and manage channels in Kroolo",
      id: 6,
      thumb: createManageChannels,
    },
    {
      videoid: "kgMMbYaWZo0",
      title: "Add Members in Channels",
      description:
        "This video explains how you can add new members in your channels.",
      id: 6,
      thumb: addMembersInChannels,
    },
    {
      videoid: "XkFB89p45RI",
      title: "Send Voice Notes in Channels",
      description:
        "Watch this video to see how to use voice notes for communication in channels.",
      id: 6,
      thumb: sendVoiceNotesInChannels,
    },
    {
      videoid: "Z2_iK-4ZFQ8",
      title: "Convert Messages into Tasks",
      description:
        "Watch this video to see how to easily convert messages into tasks.",
      id: 6,
      thumb: convertMessagesIntoTasks,
    },
    {
      videoid: "_n3rAC3n7yc",
      title: "Mention Anything in Channels",
      description:
        "Watch this video to see how to use mentions effectively in your channels.",
      id: 6,
      thumb: mentionAnythingInChannels,
    },
  ],
  docs: [
    {
      videoid: "kSP--iBZTeE",
      title: "Create Docs Using Kroolo AI",
      description:
        "Watch this video to see how to use Kroolo AI to create documents.",
      id: 7,
      thumb: createDocsUsingKrooloAi,
    },
    {
      videoid: "Ho-If9K2ixk",
      title: "Chat with Docs Using Kroolo AI",
      description:
        "In this video, you’ll see how to chat with documents using the Kroolo AI.",
      id: 7,
      thumb: chatWithDocsUsingKrooloAI,
    },
    {
      videoid: "RlXDOXGCMbM",
      title: "Embed Files in Docs",
      description:
        "In this video, you’ll learn how you can embed files into your documents.",
      id: 7,
      thumb: embededFilesInDocs,
    },
    {
      videoid: "yKCb0qrvGqU",
      title: "Share Docs",
      description:
        "Watch this video to see how to share docs and collaborate with others.",
      id: 7,
      thumb: shareDocs,
    },
    {
      videoid: "J_DXxZZ92e0",
      title: "Manage Docs",
      description:
        "Learn how to organize and manage your documents effectively in Kroolo",
      id: 7,
      thumb: manageDocs,
    },
    {
      videoid: "sEYgNG8xsx4",
      title: "Create Sub Docs",
      description:
        "This video shows how you can create sub-docs within your main document.",
      id: 7,
      thumb: createSubDocs,
    },
    {
      videoid: "Qd6tQRsya0M",
      title: "Import Docs from Confluence",
      description:
        "Watch this video to see how to transfer documents from Confluence to Kroolo.",
      id: 7,
      thumb: importDocsFromConfluence,
    },
  ],
  teams: [
    {
      videoid: "Orda9BdKTcA",
      title: "Create and Manage Teams",
      description:
        "Watch this video to see how to create and manage teams in Kroolo.",
      id: 8,
      thumb: createAndManageTeams,
    },
    {
      videoid: "ooCUp27O-hw",
      title: "Manage Members in Teams",
      description: "This video explains how you can manage members in teams.",
      id: 8,
      thumb: manageMembersInTeams,
    },
  ],
  integrations: [
    {
      videoid: "vg9ChDN0c9M",
      title: "Import Projects from Trello",
      description:
        "Watch this video to see how to import Trello boards and start working in Kroolo.",
      id: 9,
      thumb: importProjectsFromTrello,
    },
    {
      videoid: "rAnsuI1ubZI",
      title: "Jira Integration",
      description:
        "Watch this video to see how to connect Jira to Kroolo and import your projects.",
      id: 9,
      thumb: jiraIntegration,
    },
    {
      videoid: "WFo4VSnDI84",
      title: "Asana Integration",
      description:
        "Watch this video to see how you can connect Asana to Kroolo and import your projects.",
      id: 9,
      thumb: asanaIntegration,
    },
    {
      videoid: "VWn33ZxMGhA",
      title: "Import Projects from ClickUp",
      description:
        "Learn how you can transfer projects from ClickUp to Kroolo easily.",
      id: 9,
      thumb: importProjectsFromClickUp,
    },
    {
      videoid: "6zOwvFwSDQA",
      title: "Todoist Integration",
      description:
        "This video explains how you can connect Todoist with Kroolo.",
      id: 9,
      thumb: todoistIntegration,
    },
    {
      videoid: "rM4kQkRzs0g",
      title: "Linear Integration",
      description: "Learn how you can connect Linear with Kroolo.",
      id: 9,
      thumb: linearIntegration,
    },
    {
      videoid: "E6acXmJymws",
      title: "TickTick Integration",
      description:
        "This video explains how you can connect TickTick with Kroolo.",
      id: 9,
      thumb: tickTickIntegration,
    },
    {
      videoid: "mgvJRV7Wfnw",
      title: "Smartsheet Integration",
      description:
        "This video explains how you can connect Smartsheet with Kroolo.",
      id: 9,
      thumb: smartsheetIntegration,
    },
    {
      videoid: "8PTYMfT48Pc",
      title: "Basecamp Integration",
      description:
        "This video shows how you can integrate Basecamp with Kroolo.",
      id: 9,
      thumb: basecampIntegration,
    },
    {
      videoid: "HRqEScDYNYc",
      title: "Airtable Integration",
      description: "Watch this video to see how to sync Airtable with Kroolo.",
      id: 9,
      thumb: airtableIntegration,
    },
    {
      videoid: "yMn_VcV6F1E",
      title: "Sync Github with Projects",
      description:
        "This video shows how you can sync Github with projects to automate pull requests.",
      id: 9,
      thumb: syncGithubWithProjects,
    },
    {
      videoid: "falIj5Xy6a0",
      title: "Sync Gitlab with Projects",
      description:
        "Watch this video to see how you can sync Gitlab with Kroolo.",
      id: 9,
      thumb: syncGitLabWithProjects,
    },
  ],
  automations: [
    {
      videoid: "0aEngk07DmI",
      title: "Create and Manage Automations",
      description: "Learn how you can create and manage automations in Kroolo.",
      id: 10,
      thumb: createAndManageAutomations,
    },
    {
      videoid: "0n24Z7GVd9A",
      title: "Outlook Email Automation",
      description:
        "Watch this video to see how you can create outlook email automations in projects.",
      id: 10,
      thumb: outlookEmailAutomation,
    },
    {
      videoid: "2pJJAKc82D0",
      title: "Automate Gmail Updates",
      description:
        "Watch this video to see how you can create gmail automations.",
      id: 10,
      thumb: automateGmailUpdates,
    },
    {
      videoid: "MFgePYi9Jkc",
      title: "Reassign Tasks Automatically",
      description:
        "Watch this video to see how can reassign tasks automatically.",
      id: 10,
      thumb: reassignTasksAutomatically,
    },
    {
      videoid: "pNCOewJK4Fs",
      title: "Add Hubspot Automations in Projects",
      description:
        "Watch this video to see how you can add Hubspot automations in projects.",
      id: 10,
      thumb: addHubspotAutomationsInProjects,
    },
    {
      videoid: "W_jDO9zecgc",
      title: "Salesforce Automation",
      description:
        "This video explains how you can add Salesforce automations in projects.",
      id: 10,
      thumb: salesforceAutomation,
    },
  ],
};
